// System dependencies

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Application dependencies

import {
  FormErrorFields,
  FormErrorRedux,
} from "@/interfaces/formError.interfaces";
import { RootState } from "@/redux/store";

// State

const initialState: FormErrorRedux = {
  [FormErrorFields.ButtonCaption]: "",
  [FormErrorFields.ButtonRoute]: "",
  [FormErrorFields.Code]: "",
  [FormErrorFields.IsActive]: false,
  [FormErrorFields.Message]: "",
  [FormErrorFields.ShowClose]: false,
};

// Slices

const formErrorSlice = createSlice({
  name: "formError",
  initialState: initialState,
  reducers: {
    formErrorActive: (state, action: PayloadAction<FormErrorRedux>) => {
      state[FormErrorFields.ButtonCaption] = action.payload[
        FormErrorFields.ButtonCaption
      ]
        ? action.payload[FormErrorFields.ButtonCaption]
        : "";
      state[FormErrorFields.ButtonRoute] = action.payload[
        FormErrorFields.ButtonRoute
      ]
        ? action.payload[FormErrorFields.ButtonRoute]
        : "";
      state[FormErrorFields.Code] = action.payload[FormErrorFields.Code]
        ? action.payload[FormErrorFields.Code]
        : "404";
      state[FormErrorFields.IsActive] =
        action.payload[FormErrorFields.IsActive];
      state[FormErrorFields.Message] = action.payload[FormErrorFields.Message]
        ? action.payload[FormErrorFields.Message]
        : "This page could not be found";
      state[FormErrorFields.ShowClose] = action.payload[
        FormErrorFields.ShowClose
      ]
        ? action.payload[FormErrorFields.ShowClose]
        : false;
      return state;
    },
  },
});

// Exports

export const { formErrorActive } = formErrorSlice.actions;

export const getFormErrorSelector = (state: RootState) => state.formError;

export default formErrorSlice.reducer;
